import React from 'react';
import PropTypes from 'prop-types';

import useUploadResumeOrCreateProfileWizard from '@zr/jobseeker-public/apps/jobseeker-screens/components/Screens/ScreenTypes/UploadResumeOrCreateProfile/useUploadResumeOrCreateProfileWizard';
import { NAME, PHONE_NUMBER } from '@zr/utilities/profileFields';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';
import { uploadResumeOrCreateProfilePropTypes, UPLOAD_RESUME_OR_CREATE_PROFILE } from '../../../screenTypeSchema';
import useUploadResumeOrCreateProfileTelemetry from './useUploadResumeOrCreateProfileTelemetry';

export function UploadResumeOrCreateProfile({
  applyData,
  onError,
  onScreenTypeFinish: onComplete,
  screenTypeParameters,
  setIsLoading,
}) {
  const initialContact = {
    [NAME]: screenTypeParameters[NAME] || '',
    [PHONE_NUMBER]: screenTypeParameters[PHONE_NUMBER] || '',
  };

  const {
    autologin,
    method,
    is_mobile: isMobile,
    resume_required: resumeRequired,
  } = applyData;

  const {
    // jobseeker that has these entries can skip those screens
    // (plus we would have to deal with merging their existing ones as well)
    profile_has_job_history: skipExperience,
    profile_has_school_history: skipEducation,
  } = screenTypeParameters;

  // this telemetry hook keeps track of super properties, index, and added properties throughout callbacks when we want to log screen events
  // Telemetry Sheet: https://docs.google.com/spreadsheets/d/1GZfOsbY28NGIoFuXXAVBbrW9cSZ_1Y7zJscJlQbAL28/edit#gid=100473960
  const telemetry = useUploadResumeOrCreateProfileTelemetry(UPLOAD_RESUME_OR_CREATE_PROFILE, applyData);
  const Screen = useUploadResumeOrCreateProfileWizard({
    autologin,
    initialContact,
    isMobile,
    method,
    onComplete,
    onError,
    resumeRequired,
    setIsLoading,
    skipEducation,
    skipExperience,
    strings: null,
    telemetry,
  });

  return (
    <div className="UploadResumeOrCreateProfile">
      {Screen}
    </div>
  );
}

UploadResumeOrCreateProfile.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onError: PropTypes.func.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  screenTypeParameters: uploadResumeOrCreateProfilePropTypes.isRequired,
  setIsLoading: PropTypes.func,
};

UploadResumeOrCreateProfile.defaultProps = {
  setIsLoading: () => {},
};

export default UploadResumeOrCreateProfile;
